<template>
  <div class="item">
    <div class="item-head">
      <div class="item-head_name">
        <span v-if="item.doc_type" class="tag">Articles</span>
        <router-link
          v-if="item.url"
         :to="{ path: item.url }"
        >
          {{ item.title }}
        </router-link>
      </div>
    </div>

    <div class="">
      <!-- <div class="item-date">
        <span class="item-label">Date de publication:</span>
        <span class="item-text"> {{ item.date }}</span>
      </div> -->
      <div class="item-texte">
        <span v-html="item.text"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ArticlesListingRow',

  props: {
    item: Object
  }
}
</script>
